import type { IJiraStatusChangeRow } from '@skystone/shared';
import { jiraStatusChangesApi } from '@/services/jira-status-changes-api';
import { useApi } from '@/hooks/useApi';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { ColumnDef } from '@/components/ui';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const jiraStatusChangeColumns: ColumnDef<IJiraStatusChangeRow>[] = buildRawColumns<IJiraStatusChangeRow>([
  { key: 'id', header: 'ID' },
  { key: 'issueId', header: 'Issue ID' },
  { key: 'issueKey', header: 'Issue Key' },
  { key: 'fromStatus', header: 'From Status' },
  { key: 'toStatus', header: 'To Status' },
  { key: 'changedAt', header: 'Changed At' },
  { key: 'createdAt', header: 'Created At' },
]);

const STATUS_CHANGES_SUBTITLE =
  `${buildStandardTblSubtitle()} Showing the most recent 5000 rows; ` +
  'server-side pagination is a follow-up if the table grows beyond that cap.';

export function TblJiraStatusChangesPage() {
  const { data: rows, loading, error } = useApi(() => jiraStatusChangesApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - jira_status_changes" subtitle={STATUS_CHANGES_SUBTITLE} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={jiraStatusChangeColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('jira_status_changes')}
      />
    </PageContainer>
  );
}
